<template>
    <div class="relative overflow-hidden cursor-pointer align-bottom inline-block" @mousedown="startRipple($event)">
        <slot></slot>
        <div class="absolute rounded-full" v-for="ripple in ripples" :class="rippleClass()" :key="ripple.id"
             :style="rippleStyle(ripple)" @animationend="stopRipple(ripple)"></div>
    </div>
</template>
<script>
import Compatibility from './compatibility'

export default {
    name: 'ripple',
    props: {
        color: {
            type: String,
            default: null
        },
        rippleclass: {
            type: String,
            default: null
        },
        duration: {
            type: Number,
            default: 0.5
        }
    },

    data() {
        return {
            ripples: [],
            key: 0,
            opacity: 0
        }
    },
    methods: {
        rippleClass() {
            return {
                'theme-primary': this.color == null,
                [this.rippleClass]: this.rippleClass
            }
        },
        rippleStyle(ripple) {
            let rect = this.$el.getBoundingClientRect()
            let max
            // Calculate max dimensions using Pythagoras
            if (rect.width == rect.height) {
                // It's a square. Math.sqrt(2) == 1.412
                max = rect.width * 1.412 * 2
            } else {
                max = Math.sqrt((rect.width * rect.width) + (rect.height * rect.height)) * 2
            }
            // event.offsetX is not going to work always, because the when you
            // click on the ripple-effect itself the offsets will be relative to the parent
            let x = ripple.x - rect.left - (max / 2)
            let y = ripple.y - rect.top - (max / 2)
            let style = {
                left: x + 'px',
                top: y + 'px',
                width: max + 'px',
                height: max + 'px',
                opacity: '0',
                animation: `startRipple ${this.duration}s ease-out`,
            }
            if (this.color) {
                style.backgroundColor = this.color
            }
            return style
        },

        stopRipple() {
            this.ripples.shift()
        },

        startRipple(event) {
            // Left click only
            if (event.button == 0) {
                this.$emit('click')
            }
            // Don't start ripple if not supported
            // Otherwise rippples won't be removed
            if (!Compatibility.animSupported) {
                return
            }
            this.ripples.push({
                x: event.clientX,
                y: event.clientY,
                id: this.key++
            })
        }
    }
}
</script>
<style lang="scss" scoped>
@keyframes startRipple {
    0% {
        opacity: 0.25;
        transform: scale(0.1)
    }
    100% {
        opacity: 0;
        transform: scale(1)
    }
}
</style>
